var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E4E4E4",
    cx: 53,
    cy: 53,
    r: 53
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.647 54.6c1.373.793 2.428-.867 2.463-.927 7.8-13.51 3.025-31.03-10.486-38.83-6.51-3.76-14.263-4.702-21.442-2.778l1.247-2.16a1.647 1.647 0 0 0-.609-2.272 1.647 1.647 0 0 0-2.272.608l-3.326 5.762a1.647 1.647 0 0 0 .609 2.272l5.761 3.326a1.647 1.647 0 0 0 2.272-.609 1.647 1.647 0 0 0-.609-2.272l-2.42-1.397c6.395-1.762 13.336-.943 19.126 2.4 11.926 6.886 16.154 22.36 9.268 34.287-.044.077-.955 1.798.418 2.59z",
    fill: "#F7F7F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M51.24 32.002h3.6v4.32h-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "M53.04 32.002h1.8v4.32h-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 83.242a5.383 5.383 0 0 1-3.819-1.58 5.406 5.406 0 0 1 0-7.636l7.213-7.213 7.637 7.637-7.213 7.213A5.383 5.383 0 0 1 36 83.242zM70.081 83.242a5.383 5.383 0 0 1-3.818-1.58L59.05 74.45l7.637-7.637 7.213 7.213a5.406 5.406 0 0 1 0 7.637 5.383 5.383 0 0 1-3.819 1.579zM32.206 30.138l2.949-2.065 3.097 4.424-2.948 2.065z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3D3",
    d: "m67.83 32.495 3.097-4.423 2.95 2.065-3.099 4.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.446 46.655-2.616-3.736a7.75 7.75 0 0 1-1.292-5.829 7.749 7.749 0 0 1 3.208-5.034 7.748 7.748 0 0 1 5.829-1.293 7.75 7.75 0 0 1 5.035 3.208l2.615 3.735-12.78 8.949zM69.634 46.655l-12.779-8.949 2.616-3.735a7.749 7.749 0 0 1 5.035-3.208 7.75 7.75 0 0 1 5.829 1.293 7.75 7.75 0 0 1 3.207 5.035 7.748 7.748 0 0 1-1.292 5.828l-2.616 3.736z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.04 77.724c-11.91 0-21.6-9.69-21.6-21.6 0-11.912 9.69-21.602 21.6-21.602 11.911 0 21.601 9.69 21.601 21.601s-9.69 21.601-21.6 21.601z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.04 77.724c-11.91 0-21.6-9.69-21.6-21.6 0-11.912 9.69-21.602 21.6-21.602 11.911 0 21.601 9.69 21.601 21.601s-9.69 21.601-21.6 21.601zm0-39.602c-9.925 0-18 8.075-18 18.001 0 9.926 8.075 18.001 18 18.001 9.926 0 18.001-8.075 18.001-18 0-9.927-8.075-18.002-18-18.002z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M62.64 57.923H52.323L42.2 48.308l2.48-2.61 9.08 8.625h8.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.041 56.123c0 9.926-8.075 18.001-18 18.001v3.6c11.91 0 21.6-9.69 21.6-21.6 0-11.912-9.69-21.602-21.6-21.602v3.6c9.925 0 18 8.075 18 18.001zM53.04 32.602a5.406 5.406 0 0 1-5.4-5.4c0-2.978 2.423-5.4 5.4-5.4 2.978 0 5.4 2.422 5.4 5.4s-2.422 5.4-5.4 5.4z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.04 21.802v10.8c2.978 0 5.4-2.422 5.4-5.4s-2.422-5.4-5.4-5.4z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M53.04 53.64v4.283h9.6v-3.6h-8.88z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPast);
export default __webpack_public_path__ + "static/media/past.d9063a39f5f709662c6abbf474af14e8.svg";
export { ForwardRef as ReactComponent };